// extracted by mini-css-extract-plugin
module.exports = {"A_1":"A_A_1__Soi9X"};